import { render, staticRenderFns } from "./ItemTypeManage.vue?vue&type=template&id=5edf6ac4&scoped=true"
import script from "./ItemTypeManage.vue?vue&type=script&lang=js"
export * from "./ItemTypeManage.vue?vue&type=script&lang=js"
import style0 from "./ItemTypeManage.vue?vue&type=style&index=0&id=5edf6ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf6ac4",
  null
  
)

export default component.exports